<template>
  <keep-alive>
    <div class="wrap-device-list">
      <div class="wrap-device-list_bg">
        <div class="wrap-device-list_row">
          <div
            :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
            @click="toggleFiltersState"
          >
            <span
              class="mdi"
              :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
              @click="toggleFiltersState"
            />
            <span class="main_fiters_toggler_text">
              {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
            </span>
          </div>

          <div class="devices_wrap selects" :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'">
              <div class="device_groups">
                  <tree-select
                      :options="opt_device_groups"
                      :placeholder="translate('device.group.many')"
                      v-model="filter_devices.group"
                      :normalizer="node => ({id: Number(node.id)})"
                      :multiple="true"
                      :flat="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :hide-selected="true"
                      :preserveSearch="true"
                      :select-label="translate('select_enter')"
                      :noresult="translate('group.not_found')"
                      :disabled="filter_devices.custom_list.length > 0"
                      @input="change_group"
                  />
              </div>

              <div
                  class="custom_list"
                  :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
                  v-if="opt_custom_list.length > 0"
              >
                  <tree-select
                      :options="opt_custom_list"
                      :placeholder="translate('device.group.list')"
                      v-model="filter_devices.custom_list"
                      :multiple="true"
                      :flat="true"
                      :close-on-select="false"
                      :clear-on-select="true"
                      :hide-selected="true"
                      :preserveSearch="true"
                      :max-height="200"
                      :select-label="translate('select_enter')"
                      :noresult="translate('group.not_found')"
                      :disabled="filter_devices.group.length > 0"
                      @input="change_group"
                  />
              </div>
          </div>

          <div
              v-if="$store.getters.getPermissions.permissionGod === true"
              class="selects"
              :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
          >
              <div class="client_list" v-if="$store.getters.getPermissions.permissionGod === true">
                  <tree-select
                      :options="opt_client_list"
                      :placeholder="translate('client.one')"
                      v-model="filter_devices.client_id"
                      :multiple="true"
                      :flat="true"
                      :close-on-select="false"
                      :clear-on-select="true"
                      :hide-selected="true"
                      :preserveSearch="true"
                      :max-height="200"
                      :select-label="translate('select_enter')"
                      :noresult="translate('group.not_found')"
                      @input="change_group"
                  />

              </div>

              <div
                  class="versions_list"
                  :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
                  v-if="$store.getters.getPermissions.permissionGod === true"
              >
                  <tree-select
                      :options="firmwares_options"
                      v-model="firmwares_filter"
                      :disable-branch-nodes="true"
                      :multiple="true"
                      :loading="true"
                      :searchable="true"
                      :flat="true"
                      :max-height="200"
                      :placeholder="translate('firmwares_versions')"
                      @input="input_firmwares"
                  />

              </div>
          </div>

          <div
              class="selects"
              :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
          >
            <div class="universal_search" v-if="$store.getters.getPermissions.extendedSearchDeviceList === true">
              <fg-input
                v-model="filter_devices.universal_search"
                class="name"
                type="text"
                :clearable="true"
                :placeholder="translate('search')"
                @input="change_input"
              />
            </div>

            <div class="device_sku" v-if="$store.getters.getPermissions.skuSearchDeviceList === true">
              <tree-select
                  :options="device_sku_list"
                  :placeholder="translate('device.device_sku')"
                  v-model="filter_devices.device_sku_id"
                  :clearable="true"
                  :multiple="true"
                  @input="change_input"
              />
            </div>
          </div>

          <div
            class="manage_block selects"
            :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
            v-if="(permissions.permissionNotifications === true) || (permissions.editDeviceList === true)"
          >
            <p
                class="text-center"
                v-if="
                  filter_devices.visible ||
                  filter_devices.single_simcard ||
                  filter_devices.not_version ||
                  filter_devices.exclude_groups ||
                  filter_devices.apn
                ">
              {{ translate("settings.additional_filters")}}
            </p>

            <div class="form-group" v-if="$store.getters.getPermissions.createReports === true">
              <div class="manage">
                <div class="manage__item">
                  <span class="manage_btns mdi mdi-file-chart btn btn-primary btn-fill" @click.prevent="get_reports">
                    {{ translate('reports.create') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="number_checked > 0">
              <div class="manage">

                <div class="manage__item">
                  <span
                      v-if="permissions.editDeviceList"
                      class="manage_btns mdi mdi-format-list-bulleted-square btn btn-primary btn-fill"
                      @click.prevent="custom_device_list()"
                  >
                    {{ translate('custom.add_device_in_list') }}
                  </span>
                </div>

                <div class="manage__item">
                  <span
                      v-if="permissions.permissionNotifications"
                      class="manage_btns mdi mdi-bell btn btn-primary btn-fill"
                      @click.prevent="notifications"
                  >
                    {{ translate('notification.one') }}
                  </span>

<!--                  <span-->
<!--                      v-if="permissions.permissionNotifications"-->
<!--                      class="manage_btns mdi mdi-bell btn btn-primary btn-fill"-->
<!--                      @click.prevent="notifications"-->
<!--                  >-->
<!--                    {{ translate('notification.one') }}-->
<!--                  </span>-->
                </div>


                <div class="manage__item">
                  <span
                      v-if="permissions.runDeviceRpc"
                      class="manage_btns mdi mdi-console-line btn btn-primary btn-fill"
                      @click.prevent="send_remote_command()"
                  >
                    {{ translate('device.rpc.send_rpc') }}
                  </span>

                  <span
                      v-if="$store.getters.getPermissions.permissionGod === true"
                      class="manage_btns mdi mdi-content-copy btn btn-primary btn-fill"
                      @click.prevent="copy_fid()"
                  >
                    Copy FID
                  </span>
                </div>



              </div>
            </div>
          </div>

          <div :class="(filters_state)? 'reset-filters-wrap' : 'reset-filters-wrap--hidden'">
            <span
              class="btn btn-fill mdi-refresh mdi"
              :class="(status_filter()) ? 'btn-warning' : ''"
              @click.prevent="reset_filter"
            >
              {{ translate('filter.reset') }}
            </span>

            <span
                class="btn btn-success btn-fill mdi mdi-file-excel"
                @click.prevent="get_csv()"
            >
              Save to CSV
            </span>

            <span
                class="btn btn-info btn-fill mdi mdi-cog"
                @click.prevent="show_settings()"
            >
              {{ translate('settings.settings_filter') }}
            </span>
          </div>
        </div>
      </div>
      <div class="response_table">
        <div v-if="load" class="loader">
           <scale-loader />
        </div>
        <table>
          <thead
            ref="tableHead"
            class="table-device-list_bg"
            :class="(filters_state)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
          >
            <tr>
              <th scope="col" class="checkbox_table">
                <input type="checkbox" v-model="checkall" @change="checkAll">
                <span v-if="number_checked > 0">{{ number_checked }}</span>
              </th>
              <th
                scope="col"
                class="status table-device-list_mob-filters"
              >
                <toggle-switch-device-status
                  v-model="filter_devices.status"
                  :disabled="false"
                  :name="name"
                  @toggle="change_status"
                  @selected="selectedMethod()"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter_devices.name"
                  :label="'ID / ' + translate('device.name')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="custom_tag sim_status">
                Simcard Status
              </th>

              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter_devices.place"
                  :label="translate('device.place')"
                  @input="change_input"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter_devices.desc"
                  :label="translate('device.desc')"
                  @input="change_input"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
                v-if="$store.getters.getPermissions.viewDeviceServerList === true"
              >
                <tag-list-popup
                  v-model="filter_devices.ip"
                  :label="translate('IP')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="custom_tag uptime">
                {{ uptime_title }}
              </th>
              <th style="width: 15px" />
            </tr>

            <tr>
              <th v-if="filter_result" >
                {{ translate('filter.result') }}:
                {{ filter_result.devices + ' ' + translate('filter.devices')}},
                {{ filter_result.pages + ' ' + translate('filter.pages')}}
              </th>
            </tr>

            <tr>
              <th
                v-if="head_tr"
                class="group_res"
                @click="group_device('device_group/' + head_tr.group_id)"
                v-html="head_tr.name"
              >
              </th>
            </tr>

          </thead>
          <tbody
            ref="tableDevice"
            style="position: relative; z-index: 1"
            @scroll.passive="paint_chart($event)"
          >
            <device-item
              v-for="(item,index) in trs"
              ref="myDevice"
              class="device_item"
              :key="index"
              :index="index"
              :item="item"
              :mobile_version="mobile_version"
              @check="resetCheck"
            />
            <tr
              v-if="afterload"
              style="border:none; background-color:  transparent;"
            >
              <td> <scale-loader /> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>
import DeviceItem from './Item/Index.vue'

import ToggleSwitchDeviceStatus from 'components/UIComponents/ToggleSwitch/ToggleSwitchDeviceStatus.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'
import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import NotificationEdit from "../Notification/Tabs/DeviceNotification/Item/Edit/Index.vue";

import ModalCustomDeviceList from './Modal/AddInCustomDeviceList.vue'
import ModalSettingsDeviceList from "./Modal/Settings.vue";
import MassRPC from "components/UIComponents/MassRPC/Index.vue";
import ModalReports from "components/UIComponents/Reports/Reports.vue";

export default {
  name: 'DeviceList',
  components: {
    DeviceItem,
    SisSelect,
    ToggleSwitchDeviceStatus,
    TagListPopup
  },
  data () {
    return {
      loading: true,
      range: false,
      load: true,
      top: 0,
      uptime_history: null,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      cur_page: 1,
      next_page: 1,
      pages: 0,
      rendList: [],
      resizeList: [],
      checkall: false,
      was_checkall: false,
      uncheckList: {},
      filter_devices: {},
      head_tr: {
        name: '',
        group_id: 0
      },
      group_head: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      date: [],
      dateReport: [],
      number_checked: 0,
      filter_result: '',
      firmwares_options: [],
      firmwares_filter: [],

      time_request: null
    }
  },
  computed: {
    device_list_title() {
      if (this.$route.name !== 'device_list') return null
      const group_id = this.filter_devices.group?.[0]
      if (group_id !== undefined) {
        return this.$store.getters.getDeviceGroups.find(group => Number(group.id) === Number(group_id))?.name || ''
      }
      const custom_list_id = this.filter_devices.custom_list?.[0]
      if (custom_list_id !== undefined) {
        return this.opt_custom_list.find(list => list.id === Number(custom_list_id))?.label || ''
      }
      const client_id = this.filter_devices.client_id?.[0]
      return this.opt_client_list.find(client => client.id === Number(client_id))?.label || ''
    },
    uptime_title() {
      const seconds = Number(this.uptime_history)
      if (!Number.isFinite(seconds) || seconds <= 0) return 'Uptime'
      const value = seconds >= 3600 ? seconds / 3600 : seconds / 60
      const unit = this.translate(seconds >= 3600 ? 'date.h' : 'date.min')
      return `Uptime (${Number(value.toFixed(2))} ${unit})`
    },
    device_sku_list() {
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {id: Number(sku.id), label: sku.title}
      })
    },
    mobile_version(){
      return document.body.clientWidth < 768
    },
    opt_client_list () {
        return this.$store.getters.getClientsList.map((client) => {
          return {id: Number(client.id), label: client.name}
        })
    },
    opt_custom_list () {
      return this.$store.getters.getCustomList.map((list) => {
        return {id: Number(list.id), label: list.name}
      })
    },
    opt_device_groups () {
      return this.$store.getters.getDeviceGroupsTree
    },
    proveCopy () {
      return (navigator.clipboard !== undefined)
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    url(){
      return this.$route.fullPath
    }
  },

  watch: {
    device_list_title: {
      immediate: true,
      handler(title, previous_title) {
        if (title !== null || previous_title !== undefined) {
          this.$store.commit('updateOtherTitle', title || '')
        }
      }
    },
    url(){
      if (this.$route.name === "device_list"){
        this.check_query(true)
        this.change_input()
      }
    },
    filter_devices: {
      deep: true,
      handler(){
        if (this.$route.name === 'device_list'){
          let query = {...this.$route.query}
          for (let key in this.filter_devices) {
            switch (key) {
              case 'group':
              case 'client_id':
              case 'custom_list':
              case 'device_sku_id':
                if (this.filter_devices[key].length > 0){
                  query[key] = this.filter_devices[key].join(',')
                } else {
                  delete query[key]
                }
                break
              case 'universal_search':
                if (this.filter_devices[key]){
                  query[key] = this.filter_devices[key]
                } else {
                  delete query[key]
                }
                break
              case 'status':
                query[key] = JSON.stringify(this.filter_devices[key])
                break
            }
          }
          this.localStorage.setItem('filter_devices', JSON.stringify(this.filter_devices))
          const location = {path: this.$route.path, query}
          if (this.$router.resolve(location).route.fullPath !== this.$route.fullPath) {
            this.$router.replace(location)
          }
        }
      }
    },
    'filter_devices.versions':{
      handler: function () {
        let list = []
         Object.keys(this.filter_devices.versions).forEach((key) => {
           this.filter_devices.versions[key].forEach((elem) => {
             list.push(key + ':' + elem)
          })
        })
        this.firmwares_filter = list
        this.change_input()
      }
    },
    'filter_devices.custom_list':{
      handler: function () {
        if (this.filter_devices.custom_list.length > 0) {
          this.filter_devices.group = []
        }
      }
    },
    'filter_devices.group':{
      handler: function () {
        if (this.filter_devices.group.length > 0) {
          this.filter_devices.custom_list = []
        }
      }
    },
    opt_device_groups () {
      this.$nextTick( () => {
        if (this.group_head.length > 0) {
          this.group_head[0].$el.style.display = 'none'
          if (this.$refs.tableDevice.scrollTop <= 50) {
            this.head_tr.name = this.group_head[0].$el.firstChild.innerHTML
            this.head_tr.group_id = this.group_head[0].item.group_id
          }
        }
      } )
    },
    tableData () {
      this.assembly_trs()

      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
    }
  },
  created () {
    this.init()
    window.addEventListener('resize', this.handleResize)
  },
  activated () {
    this.init()
    this.$http.v1.getUserProfile((response) => {
      this.uptime_history = response.data.settings?.device_list?.find(setting => setting.key === 'uptime_history')?.value ?? null
    })
    this.load_firmwares_options()
    this.$refs.tableDevice.scrollTop = this.top
    if (this.$store.getters.getDeviceListChange) {
      this.$store.commit('setDeviceListChange', false)
    }
    clearInterval(this.interval_update)
    this.change_input()

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    this.top = this.$refs.tableDevice.scrollTop
    clearInterval(this.interval_update)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    get_reports(){
      let devices = []
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            devices.push(this.tableData[i][j].device_id)
          }
        }
      }

      let t = this.$createElement(ModalReports, {
        props: {
          device_ids: devices,
          filter: devices.length ? {} : JSON.parse(JSON.stringify(this.filter_devices))
        }, on: {
          update: () => {
            this.$modal.hide('modal_reports_device_list')
          },
          close: () => {
            this.$modal.hide('modal_reports_device_list')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'modal_reports_device_list'})

    },
    copy_fid(){
      let string = ""
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            string += `${this.tableData[i][j].fid}\n`
          }
        }
      }
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    input_firmwares(){
      let filter = {}
      this.firmwares_filter.forEach((firmwares)=>{
        let item = firmwares.split(':')
        if (!filter[item[0]]){
          filter[item[0]] = []
        }
        filter[item[0]].push(item[1])
      })
      this.filter_devices.versions = filter
    },
    check_query(reset = false){
      if (this.$route.query.group) {
        this.filter_devices.custom_list = []
      } else if (this.$route.query.custom_list) {
        this.filter_devices.group = []
      }
      if (reset) {
        for (let key of ['group', 'custom_list', 'client_id', 'device_sku_id']) {
          if (this.$route.query[key] === undefined) this.filter_devices[key] = []
        }
        if (this.$route.query.universal_search === undefined) this.filter_devices.universal_search = ""
      }
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
            case 'custom_list':
            case 'group':
            case 'device_sku_id':
              let device_groups = String(this.$route.query[key]).split(',')
              this.filter_devices[key] = device_groups.filter(item => item !== '').map(Number)
              break;

            case 'status':
              let status = JSON.parse(this.$route.query[key])
              for (let statusKey in status) {
                if (["online", "backup", "blocked", "tariffication"].indexOf(statusKey) > -1) {
                  this.filter_devices.status[statusKey] = status[statusKey]
                }
              }
              break;

            case 'universal_search':
              this.filter_devices[key] = this.$route.query[key]
              break;
          }
        }
      }
    },
    get_csv(){
      this.$http.v1.getDevicesCSV(this.filter_devices,(response) => {
        const csvContent = '\uFEFF' + response.data
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;'
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `Device_list ${this.get_date(Math.round(+new Date() / 1000))}.csv`
        link.click()
        window.URL.revokeObjectURL(link.href)
        this.loading = false
      })
    },
    load_firmwares_options() {
      if (this.firmwares_options.length > 0 || this.$store.getters.getPermissions.permissionGod !== true) return
      this.$http.v1.getFirmWareVersions((response) => {
        this.firmwares_options = Object.keys(response.data).map((key) => {
          return {
            id: key,
            label: key,
            isDisabled: false,
            children: response.data[key].map((elem) => {
              return {
                id: key + ':' + elem,
                label: key + ':' + elem
              }
            })
          }
        })
      })
    },
    assembly_trs: function () {
      let trs = [] // 0 - название группы, 1 - элемент
      let t = {}
      let number = 0
      let count = 0
      for (let i in this.tableData) {
        t = {
          'type': 0,
          id: i,
          count: this.group_cnt[i].count,
          online: +this.group_cnt[i].online,
          group_id: this.group_cnt[i].group_id
        }
        trs.push(t)
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            number++
          }
          if ((this.online && this.tableData[i][j].status) || !this.online) {
            this.tableData[i][j].type = 1
            trs.push(this.tableData[i][j])
          }
          count++
        }
      }
      this.checkall = (count === number);
      this.number_checked = number
      this.$set(this, 'trs', trs)
    },
    group_device(url){
      this.$router.push(url)
    },
    update_status () {
      this.date = new Date()
      for (let i = 1; i <= this.cur_page; i++) {
        this.$http.v1.getDevices(i, this.filter_devices, (response) => {
          this.pages = response.data.pages
          this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
          this.filter_result = {devices: response.data.count, pages: response.data.pages}
          for (let i in response.data.devices) {
            if (this.tableData[i] === undefined) {
              this.tableData[i] = {}
            }
            for (let j in response.data.devices[i]) {
              if (this.tableData[i][j] === undefined) {
                this.tableData[i][j] = {}
              }
              for (let k in response.data.devices[i][j]) {
                this.tableData[i][j][k] = response.data.devices[i][j][k]
              }
              this.tableData[i][j].offline = response.data.devices[i][j].offline
            }
          }
        })
      }
    },
    change_group () {
      this.change_input()
    },
    change_status (name, value) {
      this.filter_devices.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => {
        this.resizeList = [...this.$refs.myDevice];
        this.paint_chart()
      }, 300)
    },
    checkAll () {
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          this.$set(this.tableData[i][j], 'checked', this.checkall)
        }
      }

      this.assembly_trs()
    },
    resetCheck (check, item) {
      this.tableData[item.group_id][item.id].checked = check

      this.assembly_trs()
    },
    status_filter() {
      let { status, versions, ...otherFilters } = this.filter_devices;

      if (status && Object.values(status).some(value => value)) {
        return true;
      }

      if (versions && Object.keys(versions).length > 0) {
        return true;
      }

      for (let key in otherFilters) {
        if (otherFilters[key].length > 0) {
          return true;
        }
      }

      return false;
    },
    get_filter () {
      let arr = {
        group: [],
        desc: [],
        place: [],
        name: [],
        ip: [],
        custom_list:[],
        client_id:[],
        device_sku_id:[],
        versions: {},
        status: {
          online: 1,
          backup: 0,
          blocked: 0,
          tariffication: 0
        },
        visible: false,
        single_simcard: false,
        not_version: false,
        exclude_groups: false,
        apn: false,
        universal_search: ""
      }
      let res = {}

      let filter = JSON.parse(this.localStorage.getItem('filter_devices'))

      if (filter !== null) {
        for (let i in arr) {
          if (filter[i] !== undefined) {
            res[i] = filter[i]
          } else {
            res[i] = arr[i]
          }
        }
      } else {
        res = arr
      }
      for (let key of ['group', 'client_id', 'custom_list', 'device_sku_id']) {
        res[key] = res[key].map(Number)
      }
      if (res.group.length > 0) res.custom_list = []
      return res
    },

    init () {
      this.$set(this, "filter_devices", this.get_filter())
      this.check_query()
      this.date = new Date()
    },

    paint_chart () {
      const table = this.$refs.tableDevice
      this._updateCurrentGroup(table)

      let tmpRend = []

      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) &&
            this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }
      if (tmpRend.length > 0) this.resizeList = [...tmpRend]

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) &&
            this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend

      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.next_page) this.add_device_in_list()
      }
    },

    _updateCurrentGroup (table) {
      const headers = table.querySelectorAll('tr.device_item')
      if (!headers.length) return

      const containerTop = table.getBoundingClientRect().top
      let current = headers[0]

      for (let i = 0; i < headers.length; i++) {
        const elTop = headers[i].getBoundingClientRect().top
        if (elTop <= containerTop) {
          current = headers[i]
        } else {
          break
        }
      }

      this.head_tr.name = current.querySelector('td').innerHTML
      if (current.dataset.group_id) {
        this.head_tr.group_id = Number(current.dataset.group_id)
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        this.head_tr.name = ''
        this.head_tr.group_id = null
        return false
      }
      let length = (this.$refs.myDevice.length < 25) ? this.$refs.myDevice.length : 25

      for (let i = 0; i < length; i++) {
        this.$refs.myDevice[i].chartStatus = true
      }
      if (length < this.$refs.myDevice.length) {
        for (let i = 25; i < this.$refs.myDevice.length; i++) {
          this.rendList.push(this.$refs.myDevice[i])
        }
      }
      for (let i = 0; i < this.$refs.myDevice.length; i++) {
        if (this.$refs.myDevice[i].item.type === 0) {
          this.group_head.push(this.$refs.myDevice[i])
        }
      }
      if (this.group_head.length > 0) {
        this.group_head[0].$el.style.display = 'none'
        if (this.$refs.tableDevice.scrollTop <= 50) {
          this.head_tr.name = this.group_head[0].$el.firstChild.innerHTML
          this.head_tr.group_id = this.group_head[0].item.group_id
        }
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_device, 1000)
    },

    reset_filter () {
      this.filter_devices = {
        group: [],
        desc: [],
        place: [],
        name: [],
        ip: [],
        custom_list:[],
        client_id:[],
        device_sku_id:[],
        versions: {},
        status: {
          online: 0,
          backup: 0,
          blocked: 0,
          tariffication: 0
        },
        visible: false,
        single_simcard: false,
        not_version: false,
        exclude_groups: false,
        apn: false,
        universal_search: ""
      }
      this.firmwares_filter = []
      this.change_input()
    },

    get_device () {
      this.load = true
      this.group_head = []

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getDeviceListUpdate)
      this.rendList = []

      this.localStorage.setItem('filter_devices', JSON.stringify(this.filter_devices))

      this.time_request = new Date().getTime()
      let filter = {...this.filter_devices, ts_req: this.time_request}
      if (filter.universal_search === null || filter.universal_search === ""){
        delete filter.universal_search
      }

      this.$http.v1.getDevices(1, filter, (response) => {
        if (this.time_request === filter.ts_req){
          this.pages = response.data.pages
          this.next_page = response.data.next_page
          this.cur_page = response.data.current_page
          this.group_cnt = {...response.data.groups}
          this.filter_result = {devices: response.data.count, pages: response.data.pages}
          this.tableData = {...response.data.devices}

          for (let i in this.tableData) {
            for (let j in this.tableData[i]) {
              this.$set(this.tableData[i][j], 'checked', false)
            }
          }
        }
      })
    },

    add_device_in_list () {
      this.afterload = true
      this.$http.v1.getDevices(this.next_page, {...this.filter_devices}, (response) => {
        let tmp = {...this.tableData}
        for (let i in response.data.devices) {
          if (tmp[i] === undefined) {
            tmp[i] = {}
          }
          for (let j in response.data.devices[i]) {
            tmp[i][j] = response.data.devices[i][j]
          }
        }

        this.tableData = {...tmp}

        this.cur_page = response.data.current_page
        this.next_page = response.data.next_page
        this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
        this.paint_chart()
      })
    },

    report () {
      this.loading = true
      let filter = {...this.filter_devices }
      if(this.was_checkall) {
        filter['not_id'] = Object.keys(this.uncheckList)
      }
      else {
        let checkedList = []
        for (let i in this.tableData) {
          for (let j in this.tableData[i]) {
            if (this.tableData[i][j].checked) {
              checkedList.push(this.tableData[i][j].device_id)
            }
          }
        }
        if (checkedList.length === 0)  {
          this.global_notify('danger', this.translate('device.no_chosen'))
          this.loading = true
          return false
        } else {
          filter['ids'] = checkedList
        }
      }

    },

    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },

    check_group(parent, group, id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids){
      let new_group = {
        id: +group.id,
        expanded: false,
        hasExpanded: true,
        parent: group.parent,
        name: group.name,
        children: [],
        role: 'group'
      }
      if(groups_ids.indexOf(+group.id) > -1){
        new_group.checked = true
        new_group.children.push({ role: 'empty', visible: false, checked: true })
      }else{
        new_group.checked = false
        new_group.children.push({ role: 'empty', visible: false })
      }

      parent.children[id] = new_group

      if (groups_for_dev_ids.indexOf(parent.children[id].id) > -1 || groups_for_grp_ids.indexOf(parent.children[id].id) > -1) {
        parent.children[id].expanded = true
        this.$http.v1.getListDevicesByIdGroup({group_id: group.id}, (response) => {
          let devices = response.data
          for(let j in devices) {
            let device = {
              name: '(' + devices[j].fid + ') ' + '<b>' + devices[j].name2 + '</b>',
              id: devices[j].device_id,
              role: 'children',
              group_id: +group.id,
              fid: devices[j].fid
            }
            devs_ids.indexOf(+devices[j].device_id) > -1 ? device.checked = true : device.checked = false

            parent.children[id].children.push(device)
          }
        })
      }

      if (group.children) {
        for(let children_id in group.children) {
          this.check_group(parent.children[id], group.children[children_id], children_id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids);
        }
      }

    },

    notifications () {
      let devs_ids = []
      let groups_for_dev_ids = []
      let notice_list = {}
      notice_list.devices = []

      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            devs_ids.push(this.tableData[i][j].device_id)
            groups_for_dev_ids.push(this.tableData[i][j].group_id)
            groups_for_dev_ids = groups_for_dev_ids.concat(...this.$store.getters.getPathGroupById(this.tableData[i][j].group_id))

            let new_device = {
              name: '(' + this.tableData[i][j].fid + ') ' + '<b>' + this.tableData[i][j].name2 + '</b>',
              id: this.tableData[i][j].device_id,
              role: 'children',
              group_id: +this.tableData[i][j].group_id,
              checked: true,
              fid: this.tableData[i][j].fid
            }
            notice_list.devices.push(new_device)
          }
        }
      }
      if (devs_ids.length === 0)  {
        this.global_notify('danger', this.translate('device.no_chosen'))
        this.loading = true
        return false
      }

      let groups = this.$store.getters.getDeviceGroupsTree

      let group_list = {children: []}
      for(let group_id in groups) {
        this.check_group(group_list, groups[group_id], group_id, devs_ids, groups_for_dev_ids, [], []);
      }

      var t = this.$createElement(NotificationEdit, {
        props: {
          notice: notice_list,
          list_devices: group_list.children
        }, on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: false,
        scrollable: true,
        name: 'dynamic-modal'
      })

    },

    send_remote_command(){
      let devices = [];

      Object.values(this.tableData).forEach(row => {
        Object.values(row).forEach(item => {
          if (item.checked) {
            devices.push({
              name: item.name2,
              fid: item.fid,
              device_id: item.device_id
            });
          }
        });
      });

      let t = this.$createElement(MassRPC, {
        props: {
          devices
        },
        on: {
          close: () => {
            this.$modal.hide('mass_rpc')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: "auto", width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'mass_rpc'})

    },

    custom_device_list(){
      let devs_ids = []
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            devs_ids.push(this.tableData[i][j].device_id)
          }
        }
      }

      let t = this.$createElement(ModalCustomDeviceList, {
        props: {
          device_list: devs_ids,
          opt_custom_list: this.opt_custom_list
        }, on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})

    },
    show_settings(){
      let t = this.$createElement(ModalSettingsDeviceList, {
        props: {
          filter: this.filter_devices
        }, on: {
          update: (new_filter) => {
            this.filter_devices = new_filter
            this.$modal.hide('modal_settings_device_list')
          },
          close: () => {
            this.$modal.hide('modal_settings_device_list')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'modal_settings_device_list'})

    }

  }
}
</script>

<style lang="scss">

  .custom_tag{
    &.uptime{
      font-size: 0.95rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }
    &.sim_status{
      width: 170px;
      font-size: 0.95rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }
  }

  .multiselect__tags {
      max-height: 104px;
      overflow-x: hidden;
      overflow-y: auto;
  }

  .manage_btn  {
      display: inline-block !important;
      margin-top: 10px;
      padding: 0 2px 1px 0 !important;
      white-space: normal !important;
      height: 22px;
      line-height: 18px !important;
      margin-left: 5px !important;
      border-radius: 5px !important;
  }

.datepicker {
  .mx-datepicker-range {
    min-width: 0;
  }
  .mx-icon-calendar{
    display: none;
  }
  .mx-icon-clear{
    display: none;
  }
}
.wrap-device-list{
  &_row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .manage_block{
      .form-group{
        margin-bottom: 0;
        & + .form-group{
          margin-top: 5px;
        }
      }
      .text-center{
        margin-bottom: 0;
      }
      .manage{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
         flex-direction: column;
        flex-wrap: wrap;
        gap: 5px;

        &__item{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 5px;
        }
        .manage_btns{
          width: 100%;
          height: 22px;
          display: inline-block;
          white-space: normal;
          border-radius: 5px;
          padding: 0;
          overflow: hidden;
        }
        .datepicker{
          .btn{
            width: 100%;
            height: 22px;
            padding: 0;
          }
        }
      }
    }
    .selects{
      width: 25%;
      .device_groups{
        margin-bottom: 10px;
      }
      .client_list{
        margin-bottom: 10px;
      }
      .universal_search{
        margin-bottom: 10px;
        position: relative;
      }
    }
  }
  .reset-filters-wrap{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    gap: 10px;
    &--hidden{
      display: none;
    }
    //button{
    //  margin-bottom: 10px;
    //  &:last-child{
    //    margin-bottom: 0;
    //  }
    //}
    .btn{
      padding: 0 10px;
      border: 1px solid;
      width: 165px;
    }
  }
  .response_table{
    padding: 0;
    .checkbox_table{
      width: 30px;
      height: 50px;
      span{
        display: block;
        font-size: 12px;
        line-height: normal;
        text-align: center;
      }
    }
    .group_res{
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      span{
        min-width: 250px;
      }
      .client{
        text-align: right;
      }
      &:hover{
        background-color: #d5d5d5
      }
    }
    .device_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
        color: black;
        tr{
          background-color: #f1f1f1;
        }
      }
    }
  }
}

@media (max-width: 1366px) {
  .custom_tag{
    &.sim_status{
      width: 110px;
    }
  }
}

@media (max-width: 767px)  {
  .wrap-device-list {
    &_row{
      flex-direction: column;
      .selects{
        width: 100%;
        margin-right: 0;
      }
      .manage_block{
        width: 90%;
        margin-bottom: 10px;
      }
      .device_groups{
        width: 100%;
      }
      .users_list{
        width: 90%;
      }
      .versions_list{
        width: 100%;
      }
    }
    .reset-filters-wrap{
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      flex-direction: column;
      .btn{
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
  .response_table{
    margin: 0 -2px;
    &>table{
      thead.table-device-list_bg{
        padding: 10px 0;
        border: none;
        height: 80px;
        margin: auto;
        position: relative;
        overflow: visible;
        width: 100%;

        tr {
          display: block;
          border: none;
          margin: 0;
          padding: 0;
        }
        th {
          display: none;
          &.table-device-list_mob-filters {
            display: inline-block;
            width: 33%;
            height: 40px;
            z-index: 1;
          }
        }
      }
    }
  }
}

  //@media (max-width: 767px)  {
  //  .wrap-device-list {
  //    .reset-filters-wrap{
  //      flex-direction: column;
  //      .btn{
  //        width: 100%;
  //        margin-bottom: 10px;
  //      }
  //    }
  //  }
  //}
</style>
